import { combineReducers } from "redux";
import { AlertMessageReducer } from "./AlertMessageReducer";
import { loaderReducer } from "./LoaderReducer";
import { userDetailsReducer } from "./UserDetailsReducer";
import { darkModeReducer } from "./DarkModeReducer";
import { locationReducer } from "./LocationReducer";

export const rootReducer = combineReducers({
    AlertMessageReducer: AlertMessageReducer,
    loaderReducer: loaderReducer,
    userDetailsReducer: userDetailsReducer,
    darkModeReducer: darkModeReducer,
    locationReducer: locationReducer
})